import React from 'react';
import { Form, Card, Alert, Button, Badge } from 'react-bootstrap';
import { Upload } from 'antd';
import { PlusOutlined, DeleteOutlined, CameraOutlined, InfoCircleOutlined } from '@ant-design/icons';

const ScreenshotTab = ({ files, handleFilesChange, handleRemoveFile, onRemoveAll }) => (
  <div className="mt-2">
    <Card className="glass-tab-card border-0">
      <Card.Body>
        <div className="d-flex align-items-center mb-1">
          <CameraOutlined style={{ fontSize: '18px', color: '#ff3b30', marginRight: '8px' }} />
          <Card.Title className="mb-0" style={{ fontSize: '14px', color: '#1d1d1f' }}>
            Загрузка скриншотов
          </Card.Title>
          {files.length > 0 && (
            <Badge bg="primary" className="ms-2 glass-badge bg-primary" style={{ fontSize: '11px', padding: '4px 8px' }}>
              {files.length} / 10
            </Badge>
          )}
        </div>
        <Alert variant="warning" className="mb-2 py-1 px-2 border-0" style={{ fontSize: '12px', background: 'rgba(255, 149, 0, 0.1)', borderRadius: '10px' }}>
          <InfoCircleOutlined style={{ marginRight: '4px' }} />
          До 10 файлов. Вставка из буфера: Ctrl+V. Желательно с адресной строкой на скриншоте.
        </Alert>

        <Form.Group className="mb-0">
          <Form.Label className="fw-semibold mb-1" style={{ fontSize: '13px', color: '#1d1d1f' }}>
            Скриншоты <span className="text-danger">*</span>
          </Form.Label>
          <div className="d-flex gap-2 mb-2 flex-wrap">
            <Upload
              accept="image/*"
              multiple
              showUploadList={false}
              beforeUpload={() => false}
              fileList={files.map(f => ({
                uid: f.file.name + f.file.size + f.file.lastModified,
                name: f.file.name,
                status: 'done',
                originFileObj: f.file,
                thumbUrl: f.previewUrl
              }))}
              onChange={handleFilesChange}
              disabled={files.length >= 10}
            >
              <button
                type="button"
                className="glass-btn-primary-sm"
                disabled={files.length >= 10}
                style={{ display: 'flex', alignItems: 'center', gap: '6px' }}
              >
                <PlusOutlined /> Добавить файл
              </button>
            </Upload>
            {files.length > 0 && (
              <button
                type="button"
                className="glass-btn-outline-danger"
                onClick={onRemoveAll}
                style={{ display: 'flex', alignItems: 'center', gap: '6px' }}
              >
                <DeleteOutlined /> Удалить всё
              </button>
            )}
          </div>

          {files.length === 0 ? (
            <div
              className="glass-drop-zone"
              onDragOver={(e) => {
                e.preventDefault();
                e.currentTarget.classList.add('drag-over');
              }}
              onDragLeave={(e) => {
                e.currentTarget.classList.remove('drag-over');
              }}
            >
              <CameraOutlined style={{ fontSize: '28px', color: 'rgba(0,0,0,0.25)', marginBottom: '8px' }} />
              <p className="text-muted mb-0" style={{ fontSize: '13px' }}>
                Перетащите файлы или нажмите «Добавить файл»
              </p>
              <p className="text-muted" style={{ fontSize: '11px', marginTop: '4px' }}>
                PNG, JPG, JPEG, WebP
              </p>
            </div>
          ) : (
            <div
              className="d-flex flex-wrap gap-2"
              style={{
                padding: '10px',
                background: 'rgba(255, 255, 255, 0.5)',
                borderRadius: '10px',
                border: '1px solid rgba(0, 0, 0, 0.06)',
              }}
            >
              {files.map((f, idx) => (
                <Card
                  key={idx}
                  style={{
                    width: '120px',
                    position: 'relative',
                    border: '2px solid #e0e0e0',
                    borderRadius: '8px',
                    overflow: 'hidden',
                    transition: 'all 0.3s',
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.borderColor = '#1890ff';
                    e.currentTarget.style.boxShadow = '0 3px 10px rgba(0,0,0,0.12)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.borderColor = '#e0e0e0';
                    e.currentTarget.style.boxShadow = 'none';
                  }}
                >
                  <div style={{ position: 'relative', paddingTop: '100%' }}>
                    <img
                      src={f.previewUrl}
                      alt={`Скриншот ${idx + 1}`}
                      style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                      }}
                    />
                    <Button
                      size="sm"
                      variant="danger"
                      style={{
                        position: 'absolute',
                        top: '3px',
                        right: '3px',
                        borderRadius: '50%',
                        width: '24px',
                        height: '24px',
                        padding: 0,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                        fontSize: '12px',
                      }}
                      onClick={() => handleRemoveFile(idx)}
                    >
                      <DeleteOutlined />
                    </Button>
                    <Badge
                      bg="dark"
                      style={{
                        position: 'absolute',
                        bottom: '3px',
                        left: '3px',
                        fontSize: '9px',
                        padding: '2px 6px',
                      }}
                    >
                      #{idx + 1}
                    </Badge>
                  </div>
                </Card>
              ))}
            </div>
          )}
          
          {files.length > 0 && (
            <Form.Text className="text-muted mt-1 d-block" style={{ fontSize: '11px' }}>
              {files.length} из 10 — будут добавлены в протокол
            </Form.Text>
          )}
        </Form.Group>
      </Card.Body>
    </Card>
  </div>
);

export default ScreenshotTab;

